import type { BlockContent } from 'components/editor/grid/reduxStore/editorSlice';
import { PreviewBlock } from 'components/editor/GridDndEditor/Block/Preview/PreviewBlock';
import EmbedIframe from 'components/editor/embed/EmbedIframe';
import { gridPixelSize } from 'components/editor/shared/gridConfig';
import type { EmbedContent } from 'components/editor/embed/embed';
import { GridBlockType } from 'services/entities/BlockTypes';
import BrokenEmbedPreview from './BrokenEmbedPreview';

type Props = { block: BlockContent; rotation?: number };

export const PreviewEmbed = ({ block, rotation }: Props) => {
  const embedContent = block.contentObject as EmbedContent;

  return (
    <PreviewBlock key={block.blockConfig.id} gridSystemInPx={gridPixelSize} gridBlock={block} rotation={rotation}>
      {embedContent.embedUrl && embedContent.subtype && (
        <div data-block-type={GridBlockType.EMBED} style={{ width: '100%', height: '100%' }}>
          <EmbedIframe
            embedUrl={embedContent.embedUrl}
            subtype={embedContent.subtype}
            blockId={block.blockConfig.id}
            renderFallback={() => <BrokenEmbedPreview />}
          />
        </div>
      )}
    </PreviewBlock>
  );
};
